module.exports = {
  $vuetify: require('vuetify/es5/locale/de').default,
  Lang: {
    change: 'Sprache wechseln',
    name: 'Deutsch',
    iso: 'de_DE',
  },
  Action: {
    add: 'Hinzufügen',
    edit: 'Bearbeiten',
    remove: 'Entfernen',
    close: 'Schließen',
    select: 'Auswählen',
    save: 'Speichern',
    saving: 'Wird gespeichert',
    send: 'Senden',
    confirmSelection: 'Auswahl bestätigen',
    change: 'Ändern',
    changeSelection: 'Auswahl ändern',
    next: 'Weiter',
    prev: 'Zurück',
    finish: 'Fertig',
    search: 'Suche',
    print: 'Drucken',
    returnToList: 'Abbrechen',
    goToCart: 'Zum Einkaufswagen',
    clearCart: 'Warenkorb löschen',
    placeOrder: 'Bestellung abschließen',
    addToCart: 'In den Einkaufswagen',
  },
  Common: {
    category: 'Kategorie',
    date: 'Datum',
    creationdate: 'Erstellungsdatum',
    lastmodified: 'Letzte Änderung',
    status: 'Status',
    color: 'Farbe',
    settings: 'Einstellungen',
    filterText: 'Text filtern',
    masterdata: 'Stammdaten',
    masterdataSaved: 'Stammdaten wurden gespeichert',
    price: 'Preis',
    amount: 'Betrag',
    description: 'Beschreibung',
    item: 'Artikel',
    itemNum: 'Artikel Nr.',
    itemName: 'Artikelname',
    itemPrice: 'Artikelpreis',
    quantity: 'Anzahl',
    singlePrice: 'Einzelpreis',
    discount: 'Nachlass',
    rebate: 'Rabatt',
    netAmount: 'Netto-Betrag',
    taxAmount: 'Steuerbetrag',
    taxPercent: 'MwSt (%)',
    grossAmount: 'Bruttobetrag',
    total: 'Gesamt',
    orderPrice: 'Bestellpreis',
    annotation: 'Anmerkung',
    accountDetails: 'Kundendaten',
    customerNum: 'Kundennummer',
    salutation: 'Anrede',
    firstname: 'Vorname',
    lastname: 'Nachname',
    company: 'Firma',
    email: 'E-Mail',
    contact: 'Anschrift',
    address: 'Adresse',
    postalcode: 'PLZ',
    city: 'Stadt',
    country: 'Land',
    taxDetails: 'Steuerdaten',
    vatId: 'USt.-ID Nr.',
    noentries: 'Keine Einträge',
    languageSettings: 'Spracheinstellungen',
    showXtoYentries: 'Zeige {x} bis {y} Ergebnisse',
    showXtoYofZentries: 'Zeige {x} bis {y} von {z} Ergebnissen',
    errorSavingMasterdata: 'Stammdaten konnten nicht gespeichert werden.',
    errorIncomplete: 'Formular unvollständig',
    errorFieldMissing: '{field} muss ausgefüllt sein',
    errorUploadInvalidResp: 'Ungültige Server-Antwort. Bitte versuchen Sie es erneut oder wenden Sie sich an unseren Support.',
    name: 'Name',
    filename: 'Dateiname',
    ticketnum: 'Ticket Nr.',
    duedate: 'Fälligkeitsdatum',
    ouragent: 'Unser Agent',
    nickname: 'Spitzname',
  },
  Units: {
    C62: 'Stk',
    GRM: 'g'
  },
  Application: {
    application: 'Optionen',
    cart: 'Einkaufswagen',
    shop: 'Shop',
    orders: 'Bestellungen',
    billing: 'Rechnungen',
    dashboard: 'Dashboard',
    tickets: 'Tickets',
    notes: 'Wissensdatenbank',
    reports: 'Berichte',
    deliveries: 'Lieferungen',
    offers: 'Angebote',
    invoices: 'Rechnungen',
  },
  Addresses: {
    title: 'Adressen',
    add: 'Neue Adresse',
    addressMain: 'Hauptanschrift',
    addressBilling: 'Rechnungsanschrift',
    addressShipping: 'Lieferanschrift',
    confirmRemove: 'Wollen Sie den Kontakt wirklich entfernen?',
    errorLoad: 'Adressen konnten nicht geladen werden.',
    errorRemove: 'Adresse konnte nicht gelöscht werden.'
  },
  EditAddress: {
    title: 'Neue Adresse',
    errorTypeTitle: 'Bitte legen Sie einen Adresstypen fest.',
    errorTypeText: 'Die Anschrift muss eine Liefer- und/oder eine Rechnungsanschrift sein.',
    errorCreate: 'Adresse konnte nicht angelegt werden.',
    errorUpdate: 'Adresse konnte nicht aktualisiert werden.',
    shipping: 'Lieferungen',
    useForShippingNo: 'Nicht als Lieferanschrift verwenden',
    useForShippingYes: 'Als Lieferanschrift verwenden',
    useForShippingDefault: 'Als Standard-Lieferanschrift verwenden',
    billing: 'Rechnungen',
    useForBillingNo: 'Nicht als Rechnungsanschrift verwenden',
    useForBillingYes: 'Als Rechnungsanschrift verwenden',
    useForBillingDefault: 'Als Standard-Rechnungsanschrift verwenden'
  },
  Cart: {
    PlaceOrder: {
      title: 'Bitte überprüfen und bestätigen Sie Ihre Bestellung',
      text: 'Ich habe die Bestellung geprüft und akzeptiere die <a href="{0}" target="_blank">AGB</a>',
      cancel: 'Abbrechen',
      confirm: 'Bestellung abschließen'
    }
  },
  Orders: {
    loading: 'Bestellungen werden geladen',
    currentOrders: 'Aktuelle Bestellungen',
    openOrder: 'Bestellung öffnen',
    showAll: 'Alle Bestellungen anzeigen',
    noOrders: 'Keine Bestellungen',
    orderNum: 'Auftrag Nr.',
    projectRef: 'Projektreferenz',
    statusAll: 'Alle Bestellungen',
    statusReceived: 'Eingegangen',
    statusReceivedDescr: 'Bestellung wird geprüft',
    statusInProgress: 'In Bearbeitung',
    statusInProgressDescr: 'Ihre Bestellung wird bearbeitet',
    statusInProduction: 'In Produktion',
    statusInProductionDescr: 'Fertigung hat begonnen',
    statusOnHold: 'Gehalten',
    statusCancelled: 'Storniert',
    statusCancelledDescr: 'Ihre Bestellung wurde storniert',
    statusClosed: 'Geschlossen',
    statusCompleted: 'Abgeschlossen',
    statusInvoicedCancelled: 'Teilberechnet / Storniert',
    statusPartlyDelivered: 'Teilgeliefert',
    statusPartlyDeliveredCancelled: 'Teilgeliefert / Storniert',
    statusPartlyDeliveredClosed: 'Teilgeliefert / Geschlossen',
    statusDelivered: 'Versendet',
    statusReadyForPickup: 'Abholbereit',
    errorCouldNotLoad: 'Bestellungen konnten nicht geladen werden'
  },
  OrderDetails: {
    title: 'Bestelldetails',
    deliveryNote: 'Lieferschein',
    loading: 'Bestellung wird geladen',
    trackingNum: 'Tracking-Nr.',
    manufacturingStatus: 'Fertigungsstatus',
    trackingAndBilling: 'Tracking und Abrechnung',
    creatingOrder: 'Bestellung wird erstellt',
    orderProject: 'Projekt bestellen',
    acceptTerms: 'Ich habe die <a href="{termsUrl}" target="_blank">Allgemeinen Geschäftsbedingungen</a> gelesen und akzeptiert.',
    errorNoOrderNum: 'Keine gültige Bestellnummer übergeben',
    errorCouldNotLoad: 'Bestellung konnte nicht geladen werden',
    priceNobleMetal1: 'Der endgültige Produktpreis ist bei Edelmetallen vom endgültigen Gewicht abhängig.',
    priceNobleMetal2: 'Bitte prüfen Sie hierzu Ihren Lieferschein, sobald der Auftrag abgeschlossen ist.'
  },
  Invoices: {
    title: 'Rechnungen',
    loading: 'Rechnungen werden geladen',
    invoiceNum: 'Rechnung Nr.',
    monthlyStatement: 'Monatsaufstellung',
    statusReceived: 'Eingegangen',
    statusOpen: 'Offen',
    statusHold: 'Gehalten',
    statusCancelled: 'Storniert',
    statusClosed: 'Geschlossen',
    statusPartlyPaid: 'Teilbezahlt',
    statusPartlyPaidCancelled: 'Teilbezahlt / Storniert',
    statusPartlyPaidClosed: 'Teilbezahlt / Geschlossen',
    statusPaid: 'Bezahlt',
    pinCodeTitle: 'Bitte geben Sie den {0}-stelligen PIN-Code ein',
    invalidPinCode: 'Ungültiger PIN-Code.'
  },
  Messages: {
    title: 'Nachrichten',
    noMessages: 'Keine Nachrichten',
    writeSomething: 'Schreiben Sie was...',
    errorSendingMessage: 'Nachricht konnte nicht gesendet werden.'
  },
  Login: {
    username: 'E-Mail oder Kundennummer',
    password: 'Passwort',
    passwordOld: 'Altes Passwort',
    passwordNew: 'Neues Passwort',
    passwordConfirm: 'Neues Passwort bestätigen',
    passwordSaved: 'Passwort gespeichert',
    staySignedIn: 'Angemeldet bleiben',
    login: 'Login',
    logout: 'Logout',
    enterPwd: 'Bitte geben Sie ein Passwort ein',
    invalidUserOrPwd: 'Ungültiger Benutzername/Passwort',
    errorCouldNotUpdate: 'Passwort konnte nicht gespeichert werden.',
    errorPasswordNoMatch: 'Passwörter stimmen nicht überein.',
    errorOldPassword: 'Das alte Passwort ist falsch.',
    errorNoSession: 'Keine Benutzersession gefunden. Bitte melden Sie sich an.'
  },
  ChangePin: {
    title: 'PIN ändern',
    invalidOldPin: 'Ungültige alte PIN',
    old: 'Alt',
    new: 'Neu',
    change: 'PIN ändern',
  }
};
